import RolesScreen from "app/screens/userRoles/RolesScreen";
export default function RolesPage() {
  return <RolesScreen />;
}
